import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';

const experiences = [
  { number: '01', title: 'A menu with range', text: 'African warmth meets Mediterranean brightness, from flame-grilled favourites and seafood to fresh plant-forward plates.' },
  { number: '02', title: 'A room with energy', text: 'Easy enough for a long lunch, polished enough for a celebration, and always ready for one more round.' },
  { number: '03', title: 'A place to return to', text: 'In the heart of Menlyn Maine, Fortress pairs city rhythm with generous hospitality and an atmosphere that settles you in.' },
];

const AboutUs = () => (
  <section className={css(styles.wrapper)} id="about">
    <div className={css(styles.intro)}>
      <p className={css(styles.eyebrow)}>The Fortress experience</p>
      <h2 className={css(styles.title)}>Food with feeling.<br /><em>Hospitality with purpose.</em></h2>
      <p className={css(styles.lead)}>A dining room built around the things that matter: generous plates, good people and time well spent.</p>
      <Link to="/about" className={css(styles.link)}>Our story <span>↗</span></Link>
    </div>

    <div className={css(styles.grid)}>
      {experiences.map((item) => (
        <article className={css(styles.card)} key={item.number}>
          <span className={css(styles.number)}>{item.number}</span>
          <h3 className={css(styles.cardTitle)}>{item.title}</h3>
          <p className={css(styles.text)}>{item.text}</p>
        </article>
      ))}
    </div>
  </section>
);

const styles = StyleSheet.create({
  wrapper: { background: 'var(--color-green)', color: 'var(--color-white)', padding: 'clamp(5rem,10vw,9rem) clamp(1.5rem,6vw,6.5rem)' },
  intro: { maxWidth: '850px', marginBottom: 'clamp(3.5rem,7vw,6rem)' },
  eyebrow: { fontFamily: 'var(--font-ui)', color: '#d8c594', fontSize: '.72rem', fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', marginBottom: '1.4rem' },
  title: { fontFamily: 'var(--font-base)', fontSize: 'clamp(2.8rem,5.4vw,5.6rem)', lineHeight: 1.05, fontWeight: 500, letterSpacing: '-.035em', color: 'var(--color-white)' },
  lead: { marginTop: '1.7rem', maxWidth: '590px', color: 'rgba(255,253,247,.74)', lineHeight: 1.75, fontSize: '1rem' },
  link: { display: 'inline-flex', gap: '.5rem', marginTop: '1.5rem', color: 'var(--color-white)', fontFamily: 'var(--font-ui)', fontSize: '.72rem', fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', borderBottom: '1px solid rgba(255,255,255,.35)', paddingBottom: '.3rem' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', borderTop: '1px solid rgba(255,255,255,.18)', '@media (max-width:800px)': { gridTemplateColumns: '1fr' } },
  card: { padding: '2.2rem 2.3rem 1rem 0', borderRight: '1px solid rgba(255,255,255,.18)', ':last-child': { borderRight: 0 }, '@media (min-width:801px)': { ':not(:first-child)': { paddingLeft: '2.3rem' } }, '@media (max-width:800px)': { borderRight: 0, borderBottom: '1px solid rgba(255,255,255,.18)', padding: '2rem 0', ':last-child': { borderBottom: 0 } } },
  number: { color: '#d8c594', fontFamily: 'var(--font-ui)', fontSize: '.68rem', fontWeight: 700, letterSpacing: '.14em' },
  cardTitle: { margin: '1rem 0 .8rem', fontFamily: 'var(--font-base)', fontSize: '1.65rem', fontWeight: 500 },
  text: { color: 'rgba(255,253,247,.7)', fontSize: '.92rem', lineHeight: 1.7 },
});

export default AboutUs;
